import dayjs from 'dayjs';
var duration = require('dayjs/plugin/duration');
dayjs.extend(duration);

export const durationTime = (createdAt) => {
  // need to check
  const startAt = dayjs(createdAt);
  const now = dayjs();
  const durations = dayjs.duration(now.diff(startAt), 'milliseconds');
  const hours = Math.floor(durations.asHours());
  const minutes = Math.ceil(durations.asMinutes() % 60);
  if (hours === 0) {
    return `${minutes} 分`;
  }
  return `${hours} 小時 ${minutes} 分`;
};

export const countDownFormatHelper = (value) => {
  let formatter = (num) => num.toString().padStart(2, '0');

  if (value < 60) {
    return `00:${formatter(value)}`;
  } else {
    const minute = Math.floor(value / 60);
    const second = value % 60;
    return `${formatter(minute)}:${formatter(second)}`;
  }
};
